import { render, staticRenderFns } from "./monthlyStatement.vue?vue&type=template&id=42318e6a&scoped=true"
import script from "./monthlyStatement.vue?vue&type=script&lang=js"
export * from "./monthlyStatement.vue?vue&type=script&lang=js"
import style0 from "./monthlyStatement.vue?vue&type=style&index=0&id=42318e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42318e6a",
  null
  
)

export default component.exports